import { Controller } from "@hotwired/stimulus"

const KEY_PATTERN = /^review-draft:(\d+)$/
const TEXT_FIELDS = ["name", "score", "body"]

export default class extends Controller {
  static targets = ["list", "template"]

  // Turbo が戻る操作で前の描画を復元しても、今の localStorage に合わせて描き直す
  connect() {
    const drafts = this.#drafts()
    this.listTarget.replaceChildren(...drafts.map((draft) => this.#row(draft)))
    this.element.classList.toggle("hidden", drafts.length === 0)
  }

  #row({ code, name, score, body }) {
    const row = this.templateTarget.content.firstElementChild.cloneNode(true)
    const link = row.querySelector("[data-field=name]")
    link.href = `/lawyers/${code}`
    link.textContent = name || `登録番号 ${code} の弁護士`
    row.querySelector("[data-field=score]").textContent = score ? `点数 ${score}` : "点数なし"
    row.querySelector("[data-field=body]").textContent = body
    return row
  }

  // cookie を禁止した環境では localStorage の参照自体が例外になる。そのときは何も出さない
  #drafts() {
    try {
      return Object.keys(localStorage)
        .sort()
        .flatMap((key) => {
          const code = key.match(KEY_PATTERN)?.[1]
          const draft = code && this.#parse(localStorage.getItem(key))
          return draft ? [{ ...draft, code }] : []
        })
    } catch (error) {
      if (error.name !== "SecurityError") throw error
      return []
    }
  }

  // 書き手は review_draft_controller.js だけだが、手で書き換えた値で他の下書きまで描けなくならないよう、形の違う値は飛ばす
  #parse(json) {
    try {
      const draft = JSON.parse(json)
      const valid = draft?.constructor === Object && TEXT_FIELDS.every((field) => ["string", "undefined"].includes(typeof draft[field]))
      return valid ? draft : null
    } catch (error) {
      if (!(error instanceof SyntaxError)) throw error
      return null
    }
  }
}
